import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://oqnrxrowiewwrtroegwl.supabase.co';
const SUPABASE_KEY = 'sb_publishable_WwQgxEBYbgBgCCpuC7hqTA_4pv48QMK';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);